import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import {NotificationManager} from 'react-notifications';
import axios from 'axios';
import qs from 'qs';
import { ReactComponent as Check } from '../Img/icon-check.svg';
import { ReactComponent as Bin } from '../Img/icon-bin.svg';
import { addSpace, escapeHtml, rescueHtml } from "./Tools";
import Dialog from "./Dialog";


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        overflow: 'hidden'
    },
};


const ModalUpdateUser = (props) =>
{
    const purple = '#6571FE';
    const red = '#E33636';

    const date = new Date();
    const annee = date.getFullYear();
    const mois = String(date.getMonth() + 1).padStart(2, '0');
    const jour = String(date.getDate()).padStart(2, '0');
    const dateFormatted = `${annee}-${mois}-${jour}`;
    const [aff, setAff] = useState(false);
    const [visuRetrospective, setVisuRetrospective] = useState(true);
    const [visuFichesProjets, setVisuFichesProjets] = useState(true);
    const [visuProspective, setVisuProspective] = useState(true);
    const [visuTableaudeBord, setVisuTableaudeBord] = useState(true);
    const [visuGraphiques, setVisuGraphiques] = useState(true);
    const [visuRapportFinancier, setVisuRapportFinancier] = useState(true);
    const [modifRetrospective, setModifRetrospective] = useState(true);
    const [modifFichesProjets, setModifFichesProjets] = useState(true);
    const [modifProspective, setModifProspective] = useState(true);
    const [modifTableaudeBord, setModifTableaudeBord] = useState(true);
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    const [affProjets, setAffProjets] = useState(false);
    const [listeProjets, setListeProjets] = useState([]);


    useEffect(() => {
        mount();
    }, [props.user])


    function mount()
    {
        if (props.user && props.user.id_organisme) {
            /* Récupération des projets de tous les budgets */
            axios.post('https://app-slfinance.fr/api/budgets.php', qs.stringify({
                'getBudgets': true,
                'id_organisme': props.user.id_organisme
            }))
            .then(async (res) => {
                let tmp = [];
                let i = 0;
                for (let b of res.data) {
                    tmp[i] = [b[2]];
                    i++;
                    await axios.post('https://app-slfinance.fr/api/fiches_projets.php', qs.stringify({
                        'getFichesProjets': true,
                        'id_budget': b[0]
                    }))
                    .then((result) => {
                        for (let p of result.data) {
                            tmp[i] = p;
                            i++;
                        }
                    });
                }
                setListeProjets(tmp);
            })
        }
    }

    function callbackDialog(ret) {
        if (ret === true) {
            suppress();
        }
    }

    function closeModal() {
        props.setModalVisible(false);
    }


    async function suppress()
    {
        const params = {
            'delete': true,
            'id': props.who,
            'target_id': props.user.id
        }
        
        axios.post("https://app-slfinance.fr/api/users.php", qs.stringify(params))
        .then(async (res) => {
            if (res.data.status === 1) {
                NotificationManager.success(res.data.status_message, '', 2000);
                setTimeout(() => window.location = window.location.href, 2000);
            }
            else {
                NotificationManager.warning(res.data.status_message, '', 5000);
            }
        })
        .catch((err) => {console.warn(err)})
    }

    return (
        <Modal
        isOpen={props.modalVisible}
        style={customStyles}
        ariaHideApp={false}
        onRequestClose={closeModal}
        >

        <Dialog
            setModalVisible={setDialogModalVisible}
            modalVisible={dialogModalVisible}
            callbackDialog={callbackDialog}
            message={"Confirmez la suppression :"}
        />
            <div style={{width: (window.innerWidth/1.7), maxHeight: (window.innerHeight/10*9), overflowY: 'auto'}}>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>                    
                    <div style={{flex: 1}}></div>

                    <div>
                        <p style={{color: purple, fontWeight: 'bold'}}>Utilisateur [ {props.user.id?props.user.id:null} ]</p>
                        
                        <div style={{flex: 1, margin: 5, justifyContent: 'right'}}>
                            <p>créé le : {props.user.created?props.user.created.split('-')[2]+'/'+props.user.created.split('-')[1]+'/'+props.user.created.split('-')[0]:null}</p>
                            <p>modifié le : {props.user.modified?props.user.modified.split('-')[2]+'/'+props.user.modified.split('-')[1]+'/'+props.user.modified.split('-')[0]:null}</p>
                        </div>
                    </div>

                    <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                        <button
                            className='shadow-md rounded-md'
                            style={{marginLeft: 5, backgroundColor: red, color: 'white', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: 10, paddingRight: 10}}
                            onClick={() => {
                                setDialogModalVisible(true)
                            }}
                        >
                            <Bin width="12"/>
                            <p style={{marginLeft: 5}}>Supprimer l'utilisateur</p>
                        </button>
                    </div>
                </div>

                
                <div style={{display: 'flex', marginTop: 25}}>
                    {/* Nom */}
                    <div style={{flex: 1, margin: 5, justifyContent: 'right'}}>
                        <input
                            style={{marginLeft: 0, width: 250, border: '1px solid #E9ECEF', borderRadius: 5, padding: 7, textAlign: 'center'}}
                            placeholder={props.user.nom?rescueHtml(props.user.nom):'Nom'}
                            onBlur={async(e) => {
                                if (e.target.value !== '') {
                                    var nom = escapeHtml(e.target.value).toUpperCase();
                                    
                                    const params = {
                                        'update': true,
                                        'id': props.user.id,
                                        'nom': nom
                                    }
                                    
                                    axios.post("https://app-slfinance.fr/api/users.php", qs.stringify(params))
                                    .then(async (res) => {
                                        if (res.data.status === 1) {
                                            NotificationManager.success(res.data.status_message, '', 3000);
                                            props.user.nom = nom;
                                            props.user.modified = dateFormatted
                                            e.target.value = '';
                                            await setAff(!aff);
                                        }
                                        else {
                                            NotificationManager.warning(res.data.status_message, '', 5000);
                                        }
                                    })
                                    .catch((err) => {console.warn(err)})
                                }
                            }}
                        />
                    </div>
                    
                    {/* Prenom */}
                    <div style={{flex: 1, margin: 5, justifyContent: 'right'}}>
                        <input
                            style={{marginLeft: 0, width: 250, border: '1px solid #E9ECEF', borderRadius: 5, padding: 7, textAlign: 'center'}}
                            placeholder={props.user.prenom?rescueHtml(props.user.prenom):'Prenom'}
                            onBlur={async(e) => {
                                if (e.target.value !== '') {
                                    var prenom = escapeHtml(e.target.value);
                                    
                                    const params = {
                                        'update': true,
                                        'id': props.user.id,
                                        'prenom': prenom
                                    }
                                    
                                    axios.post("https://app-slfinance.fr/api/users.php", qs.stringify(params))
                                    .then(async (res) => {
                                        if (res.data.status === 1) {
                                            NotificationManager.success(res.data.status_message, '', 3000);
                                            props.user.prenom = prenom;
                                            props.user.modified = dateFormatted
                                            e.target.value = '';
                                            await setAff(!aff);
                                        }
                                        else {
                                            NotificationManager.warning(res.data.status_message, '', 5000);
                                        }
                                    })
                                    .catch((err) => {console.warn(err)})
                                }
                            }}
                        />
                    </div>

                </div>


                <div style={{display: 'flex', marginTop: 10}}>
                    
                    {/* Email */}
                    <div style={{flex: 1, margin: 5, justifyContent: 'right'}}>
                        <input
                            style={{marginLeft: 0, width: 520, border: '1px solid #E9ECEF', borderRadius: 5, padding: 7, textAlign: 'center'}}
                            placeholder={props.user.email?rescueHtml(props.user.email):'Email'}
                            onBlur={async(e) => {
                                if (e.target.value !== '') {
                                    var email = e.target.value;
                                    
                                    const params = {
                                        'update': true,
                                        'id': props.user.id,
                                        'email': email
                                    }
                                    
                                    axios.post("https://app-slfinance.fr/api/users.php", qs.stringify(params))
                                    .then(async (res) => {
                                        if (res.data.status === 1) {
                                            NotificationManager.success(res.data.status_message, '', 3000);
                                            props.user.email = email;
                                            props.user.modified = dateFormatted
                                            e.target.value = '';
                                            await setAff(!aff);
                                        }
                                        else {
                                            NotificationManager.warning(res.data.status_message, '', 5000);
                                        }
                                    })
                                    .catch((err) => {console.warn(err)})
                                }
                            }}
                        />
                    </div>

                </div>


                <div style={{display: 'flex', marginTop: 50, alignItems: 'center', justifyContent: 'center'}}>
                    <p style={{fontSize: 20, fontWeight: 'bold'}}>Gestion des autorisations</p>
                </div>

                {/************************** PARTIE RETROSPECTIVE **************************/}

                <div className='shadow-md rounded-md' style={{margin: 30, padding: 10, backgroundColor: 'white'}}>

                    <p style={{fontWeight: 'bold'}}>Rétrospective</p>

                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', fontSize: 10}}>
                        <div style={{flex: 2}}></div>
                        <button
                            style={{flex: 0.4}}
                            onClick={() => {
                                // Enlever les droits visu et modif sur toutes les lignes
                                if (visuRetrospective === true) {
                                    props.user.droits.retro_saisie = props.user.droits.retro_saisie ? props.user.droits.retro_saisie.replace('V', '').replace('M', ''):'';
                                    props.user.droits.retro_saisie_fiscalite = props.user.droits.retro_saisie_fiscalite ? props.user.droits.retro_saisie_fiscalite.replace('V', '').replace('M', ''):'';
                                    props.user.droits.retro_saisie_dette = props.user.droits.retro_saisie_dette ? props.user.droits.retro_saisie_dette.replace('V', '').replace('M', ''):'';
                                    props.user.droits.retro_verif = props.user.droits.retro_verif ? props.user.droits.retro_verif.replace('V', '').replace('M', ''):'';
                                    props.user.droits.retro_restitution = props.user.droits.retro_restitution ? props.user.droits.retro_restitution.replace('V', '').replace('M', ''):'';
                                    setVisuRetrospective(false);
                                    setModifRetrospective(false);
                                }
                                else {
                                    // Enlever les V sur toutes les lignes pour ensuite ajouter un V
                                    props.user.droits.retro_saisie = props.user.droits.retro_saisie ? props.user.droits.retro_saisie.replace('V', ''):'';
                                    props.user.droits.retro_saisie_fiscalite = props.user.droits.retro_saisie_fiscalite ? props.user.droits.retro_saisie_fiscalite.replace('V', ''):'';
                                    props.user.droits.retro_saisie_dette = props.user.droits.retro_saisie_dette ? props.user.droits.retro_saisie_dette.replace('V', ''):'';
                                    props.user.droits.retro_verif = props.user.droits.retro_verif ? props.user.droits.retro_verif.replace('V', ''):'';
                                    props.user.droits.retro_restitution = props.user.droits.retro_restitution ? props.user.droits.retro_restitution.replace('V', ''):'';

                                    props.user.droits.retro_saisie = 'V' + (props.user.droits.retro_saisie ? props.user.droits.retro_saisie:'');
                                    props.user.droits.retro_saisie_fiscalite = 'V' + (props.user.droits.retro_saisie_fiscalite ? props.user.droits.retro_saisie_fiscalite:'');
                                    props.user.droits.retro_saisie_dette = 'V' + (props.user.droits.retro_saisie_dette ? props.user.droits.retro_saisie_dette:'');
                                    props.user.droits.retro_verif = 'V' + (props.user.droits.retro_verif ? props.user.droits.retro_verif:'');
                                    props.user.droits.retro_restitution = 'V' + (props.user.droits.retro_restitution ? props.user.droits.retro_restitution:'');
                                    setVisuRetrospective(true);
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then(() => {
                                    setAff(!aff);
                                })
                            }}>
                            <p>Visualisation</p>
                            <p style={{fontSize: 7}}>(tout cocher))</p>
                        </button>
                        <div style={{width: 15}}></div>
                        <button
                            style={{flex: 0.4}}
                            onClick={() => {
                                if (modifRetrospective === true) {
                                    props.user.droits.retro_saisie = props.user.droits.retro_saisie ? props.user.droits.retro_saisie.replace('M', ''):'';
                                    props.user.droits.retro_saisie_fiscalite = props.user.droits.retro_saisie_fiscalite ? props.user.droits.retro_saisie_fiscalite.replace('M', ''):'';
                                    props.user.droits.retro_saisie_dette = props.user.droits.retro_saisie_dette ? props.user.droits.retro_saisie_dette.replace('M', ''):'';
                                    setModifRetrospective(false);
                                }
                                else {
                                    // Ajoute un V et un M
                                    props.user.droits.retro_saisie = 'VM';
                                    props.user.droits.retro_saisie_fiscalite = 'VM';
                                    props.user.droits.retro_saisie_dette = 'VM';
                                    props.user.droits.retro_verif = 'V';
                                    props.user.droits.retro_restitution = 'V';
                                    setVisuRetrospective(true);
                                    setModifRetrospective(true);
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then(() => {
                                    setAff(!aff);
                                })
                            }}>
                            <p>Modification</p>
                            <p style={{fontSize: 7}}>(tout cocher))</p>
                        </button>
                    </div>
                
                    {/* Ligne saisie retrospective */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Saisie rétrospective</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.retro_saisie && props.user.droits.retro_saisie.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.retro_saisie = 'V' + (props.user.droits.retro_saisie ? props.user.droits.retro_saisie:'');
                                }
                                // Enlever un V et un M
                                else {
                                    props.user.droits.retro_saisie = props.user.droits.retro_saisie ? props.user.droits.retro_saisie.replace('V', '').replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.retro_saisie && props.user.droits.retro_saisie.includes('M')? true : false}
                            onChange={async(e) => {
                                // Ajouter un M
                                if (e.target.checked === true) {
                                    props.user.droits.retro_saisie = props.user.droits.retro_saisie ? props.user.droits.retro_saisie.replace('V', '').replace('M', '') + 'VM':'VM';
                                }
                                // Enlever un M
                                else {
                                    props.user.droits.retro_saisie = props.user.droits.retro_saisie ? props.user.droits.retro_saisie.replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                    </div>
                    }
                    
                    {/* Ligne saisie retrospective fiscalité */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Saisie fiscalité rétrospective</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.retro_saisie_fiscalite && props.user.droits.retro_saisie_fiscalite.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.retro_saisie_fiscalite = 'V' + (props.user.droits.retro_saisie_fiscalite ? props.user.droits.retro_saisie_fiscalite:'');
                                }
                                // Enlever un V
                                else {
                                    props.user.droits.retro_saisie_fiscalite = props.user.droits.retro_saisie_fiscalite ? props.user.droits.retro_saisie_fiscalite.replace('V', '').replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.retro_saisie_fiscalite && props.user.droits.retro_saisie_fiscalite.includes('M')? true : false}
                            onChange={async(e) => {
                                // Ajouter un M
                                if (e.target.checked === true) {
                                    props.user.droits.retro_saisie_fiscalite = props.user.droits.retro_saisie_fiscalite ? props.user.droits.retro_saisie_fiscalite.replace('V', '').replace('M', '') + 'VM':'VM';
                                }
                                // Enlever un M
                                else {
                                    props.user.droits.retro_saisie_fiscalite = props.user.droits.retro_saisie_fiscalite ? props.user.droits.retro_saisie_fiscalite.replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                    </div>
                    }
                    
                    {/* Ligne saisie retrospective dette */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Saisie dette rétrospective</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.retro_saisie_dette && props.user.droits.retro_saisie_dette.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.retro_saisie_dette = 'V' + (props.user.droits.retro_saisie_dette ? props.user.droits.retro_saisie_dette:'');
                                }
                                // Enlever un V
                                else {
                                    props.user.droits.retro_saisie_dette = props.user.droits.retro_saisie_dette ? props.user.droits.retro_saisie_dette.replace('V', '').replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.retro_saisie_dette && props.user.droits.retro_saisie_dette.includes('M')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V et un M
                                if (e.target.checked === true) {
                                    props.user.droits.retro_saisie_dette = props.user.droits.retro_saisie_dette ? props.user.droits.retro_saisie_dette.replace('V', '').replace('M', '') + 'VM':'VM';
                                }
                                // Enlever un M
                                else {
                                    props.user.droits.retro_saisie_dette = props.user.droits.retro_saisie_dette ? props.user.droits.retro_saisie_dette.replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                    </div>
                    }
                    
                    {/* Ligne vérif retrospective */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Vérification de la rétrospective</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.retro_verif && props.user.droits.retro_verif.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.retro_verif = 'V' + (props.user.droits.retro_verif ? props.user.droits.retro_verif:'');
                                }
                                // Enlever un V
                                else {
                                    props.user.droits.retro_verif = props.user.droits.retro_verif ? props.user.droits.retro_verif.replace('V', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <div style={{flex: 0.4}}></div>
                    </div>
                    }
                    
                    {/* Ligne restitution retrospective */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Restitution de la rétrospective</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.retro_restitution && props.user.droits.retro_restitution.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.retro_restitution = 'V' + (props.user.droits.retro_restitution ? props.user.droits.retro_restitution:'');
                                }
                                // Enlever un V
                                else {
                                    props.user.droits.retro_restitution = props.user.droits.retro_restitution ? props.user.droits.retro_restitution.replace('V', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <div style={{flex: 0.4}}></div>
                    </div>
                    }
                </div>



                {/************************** PARTIE FICHES PROJETS **************************/}

                <div className='shadow-md rounded-md' style={{margin: 30, marginTop: 50, padding: 10, backgroundColor: 'white'}}>

                    <p style={{fontWeight: 'bold'}}>Fiches projets</p>

                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', fontSize: 10}}>
                        <div style={{flex: 2}}></div>

                        <button
                            style={{flex: 0.4}}
                            onClick={() => {
                                // Enlever les droits visu V et modif M sur toutes les lignes
                                if (visuFichesProjets === true) {
                                    props.user.droits.fp_pilotage = props.user.droits.fp_pilotage ? props.user.droits.fp_pilotage.replace('V', '').replace('M', ''):'';
                                    props.user.droits.fp_rapport = props.user.droits.fp_rapport ? props.user.droits.fp_rapport.replace('V', ''):'';
                                    props.user.droits.fp_synthese_globale = props.user.droits.fp_synthese_globale ? props.user.droits.fp_synthese_globale.replace('V', ''):'';

                                    // Enleve l'utilisateur de tous les projets pour la visu [34] et la modif [35]
                                    var tmp = listeProjets;
                                    tmp.forEach((element, index) => {
                                        if (element.length > 1) {
                                            let arr_34 = element[34] ? element[34].split(';') : [];
                                            arr_34 = arr_34.filter(id => id !== props.user.id);
                                            tmp[index][34] = arr_34.join(';');

                                            let arr_35 = element[35] ? element[35].split(';') : [];
                                            arr_35 = arr_35.filter(id => id !== props.user.id);
                                            tmp[index][35] = arr_35.join(';');

                                            // sauvegarde du projet
                                            var params = {
                                                'updateProjet': true,
                                                'projet': tmp[index]
                                            };
                                            axios.post("https://app-slfinance.fr/api/fiches_projets.php", qs.stringify(params))
                                        }
                                    });
                                    setListeProjets(tmp);
                                    setVisuFichesProjets(false);
                                    setModifFichesProjets(false);
                                }
                                else {
                                    // Enlever les V sur toutes les lignes pour ensuite ajouter un V
                                    props.user.droits.fp_pilotage = props.user.droits.fp_pilotage ? props.user.droits.fp_pilotage.replace('V', ''):'';
                                    props.user.droits.fp_rapport = props.user.droits.fp_rapport ? props.user.droits.fp_rapport.replace('V', ''):'';
                                    props.user.droits.fp_synthese_globale = props.user.droits.fp_synthese_globale ? props.user.droits.fp_synthese_globale.replace('V', ''):'';

                                    props.user.droits.fp_pilotage = 'V' + (props.user.droits.fp_pilotage ? props.user.droits.fp_pilotage:'');
                                    props.user.droits.fp_rapport = 'V' + (props.user.droits.fp_rapport ? props.user.droits.fp_rapport:'');
                                    props.user.droits.fp_synthese_globale = 'V' + (props.user.droits.fp_synthese_globale ? props.user.droits.fp_synthese_globale:'');

                                    var tmp = listeProjets;
                                    tmp.forEach((element, index) => {
                                        if (element.length > 1) {
                                            let arr_34 = element[34] ? element[34].split(';') : [];
                                            arr_34 = arr_34.filter(id => id !== props.user.id);
                                            tmp[index][34] = arr_34.join(';');

                                            // Ajouter l'utilisateur
                                            if (element[34] && element[34] !== '') {
                                                element[34] = element[34] + ';' + props.user.id;
                                            }
                                            else {
                                                element[34] = props.user.id;
                                            }

                                            var params = {
                                                'updateProjet': true,
                                                'projet': tmp[index]
                                            };
                                            axios.post("https://app-slfinance.fr/api/fiches_projets.php", qs.stringify(params))
                                        }
                                    });
                                    setListeProjets(tmp);
                                    setVisuFichesProjets(true);
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then(() => {
                                    setAff(!aff);
                                })
                            }}>
                            <p>Visualisation</p>
                            <p style={{fontSize: 7}}>(tout cocher))</p>
                        </button>

                        <div style={{width: 15}}></div>

                        <button
                            style={{flex: 0.4}}
                            onClick={() => {
                                // Enlever les droits modif sur toutes les lignes
                                if (modifFichesProjets === true) {
                                    props.user.droits.fp_pilotage = props.user.droits.fp_pilotage ? props.user.droits.fp_pilotage.replace('M', ''):'';

                                    // Enleve l'utilisateur de tous les projets pour la modif [35]
                                    var tmp = listeProjets;
                                    tmp.forEach((element, index) => {
                                        if (element.length > 1) {
                                            let arr_35 = element[35] ? element[35].split(';') : [];
                                            arr_35 = arr_35.filter(id => id !== props.user.id);
                                            tmp[index][35] = arr_35.join(';');

                                            // sauvegarde du projet
                                            var params = {
                                                'updateProjet': true,
                                                'projet': tmp[index]
                                            };
                                            axios.post("https://app-slfinance.fr/api/fiches_projets.php", qs.stringify(params))
                                        }
                                    });
                                    setListeProjets(tmp);

                                    setModifFichesProjets(false);
                                }
                                else {
                                    // Ajouter un V et un M
                                    props.user.droits.fp_pilotage = 'VM';
                                    props.user.droits.fp_rapport = 'V';
                                    props.user.droits.fp_synthese_globale = 'V';

                                    var tmp = listeProjets;
                                    tmp.forEach((element, index) => {
                                        if (element.length > 1) {
                                            let arr_34 = element[34] ? element[34].split(';') : [];
                                            arr_34 = arr_34.filter(id => id !== props.user.id);
                                            tmp[index][34] = arr_34.join(';');
                                            
                                            let arr_35 = element[35] ? element[35].split(';') : [];
                                            arr_35 = arr_35.filter(id => id !== props.user.id);
                                            tmp[index][35] = arr_35.join(';');

                                            // Ajouter l'utilisateur
                                            if (element[34] && element[34] !== '') {
                                                element[34] = element[34] + ';' + props.user.id;
                                            }
                                            else {
                                                element[34] = props.user.id;
                                            }

                                            if (element[35] && element[35] !== '') {
                                                element[35] = element[35] + ';' + props.user.id;
                                            }
                                            else {
                                                element[35] = props.user.id;
                                            }

                                            var params = {
                                                'updateProjet': true,
                                                'projet': tmp[index]
                                            };
                                            axios.post("https://app-slfinance.fr/api/fiches_projets.php", qs.stringify(params))
                                        }
                                    });
                                    setListeProjets(tmp);
                                    setVisuFichesProjets(true);
                                    setModifFichesProjets(true);
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then(() => {
                                    setAff(!aff);
                                })
                            }}>
                            <p>Modification</p>
                            <p style={{fontSize: 7}}>(tout cocher))</p>
                        </button>
                    </div>
                    
                    {/* Ligne Pilotage des fiches projets */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <div style={{display: 'flex', flex: 2, alignItems: 'center'}}>
                            <p>Pilotage des projets</p>
                            <p style={{fontStyle: 'italic', fontSize: 10, marginLeft: 5, textAlign: 'center'}}>(Cochez 'Modification' pour pouvoir créer des projets)</p>
                        </div>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.fp_pilotage && props.user.droits.fp_pilotage.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.fp_pilotage = 'V' + (props.user.droits.fp_pilotage ? props.user.droits.fp_pilotage : '');
                                }
                                // Enlever un V et un M
                                else {
                                    props.user.droits.fp_pilotage = props.user.droits.fp_pilotage ? props.user.droits.fp_pilotage.replace('V', '').replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.fp_pilotage && props.user.droits.fp_pilotage.includes('M')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V et un M
                                if (e.target.checked === true) {
                                    props.user.droits.fp_pilotage = 'VM';
                                }
                                // Enlever un M
                                else {
                                    props.user.droits.fp_pilotage = props.user.droits.fp_pilotage ? props.user.droits.fp_pilotage.replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                    </div>
                    }
                    
                    {/* Ligne Pilotage des fiches projets */}
                    {props.user.droits && 
                    <button
                    style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14, color: purple}}
                    onClick={() => {
                        setAffProjets(!affProjets);
                    }}>
                        <p style={{flex: 2}}>Gestion des droits des projet</p>
                        {affProjets === true?
                        <p style={{marginLeft: 20, fontSize: 25}}>▼</p>
                        :
                        <p style={{marginLeft: 20, fontSize: 25}}>▲</p>
                        }
                    </button>
                    }

                    
                    {/* Liste des projets */}
                    {affProjets && listeProjets.map((p, i) => (
                        p.length > 1?
                        <div key={i} style={{display: 'flex', marginTop: 10, marginLeft: 20, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                            <p style={{flex: 2}}>[{p[2]}] - {p[3]}</p>
                            <input
                                style={{flex: 0.4, marginLeft: -20}}
                                type="checkbox"
                                checked={p[34] && p[34].split(';').includes(props.user.id) ? true : false}
                                onChange={async(e) => {
                                    if (p[34] && p[34].split(';').includes(props.user.id)) {
                                        // Enlever l'utilisateur
                                        
                                        let arr_34 = p[34] ? p[34].split(';') : [];
                                        arr_34 = arr_34.filter(id => id !== props.user.id);
                                        p[34] = arr_34.join(';');
                                        
                                        let arr_35 = p[35] ? p[35].split(';') : [];
                                        arr_35 = arr_35.filter(id => id !== props.user.id);
                                        p[35] = arr_35.join(';');
                                    }
                                    else {
                                        // Ajouter l'utilisateur
                                        if (p[34] && p[34] !== '') {
                                            p[34] = p[34] + ';' + props.user.id;
                                        }
                                        else {
                                            p[34] = props.user.id;
                                        }
                                    }
                                    var tmp = listeProjets;
                                    tmp[i] = p;
                                    await setListeProjets(tmp);

                                    // UPDATE le projet
                                    var params = {
                                        'updateProjet': true,
                                        'projet': tmp[i]
                                    };
                                    await axios.post("https://app-slfinance.fr/api/fiches_projets.php", qs.stringify(params))
                                    await setAff(!aff);
                                }}
                            />
                            <div style={{width: 15}}></div>
                            <input
                                style={{flex: 0.4}}
                                type="checkbox"
                                checked={p[35] && p[35].split(';').includes(props.user.id) ? true : false}
                                onChange={async(e) => {
                                    // Si l'utilisateur est deja dans la liste, on l'enleve
                                    if (p[35] && p[35].split(';').includes(props.user.id))
                                    {
                                        let arr_35 = p[35] ? p[35].split(';') : [];
                                        arr_35 = arr_35.filter(id => id !== props.user.id);
                                        p[35] = arr_35.join(';');
                                    }
                                    else {
                                        // Ajouter l'utilisateur
                                        if (p[34] && !p[34].split(';').includes(props.user.id))
                                        {
                                            if (p[34] && p[34] !== '') {
                                                p[34] = p[34] + ';' + props.user.id;
                                            }
                                        }
                                        else {
                                            p[34] = props.user.id;
                                        }
                                        if (p[35] && p[35] !== '') {
                                            p[35] = p[35] + ';' + props.user.id;
                                        }
                                        else {
                                            p[35] = props.user.id;
                                        }
                                    }
                                    var tmp = listeProjets;
                                    tmp[i] = p;
                                    await setListeProjets(tmp);

                                    // UPDATE le projet
                                    var params = {
                                        'updateProjet': true,
                                        'projet': tmp[i]
                                    };
                                    await axios.post("https://app-slfinance.fr/api/fiches_projets.php", qs.stringify(params))
                                    await setAff(!aff);
                                }}
                            />
                        </div>
                        :
                        listeProjets[i+1] && listeProjets[i+1].length > 1 &&
                        <div key={i} style={{display: 'flex', marginTop: 10, marginLeft: 20, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                            <p style={{flex: 2, fontWeight: 'bold'}}>{p[0]}</p>
                        </div>
                    ))}

                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Rapport des fiches projets</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.fp_rapport && props.user.droits.fp_rapport.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.fp_rapport = 'V' + (props.user.droits.fp_rapport ? props.user.droits.fp_rapport:'');
                                }
                                // Enlever un V
                                else {
                                    props.user.droits.fp_rapport = props.user.droits.fp_rapport ? props.user.droits.fp_rapport.replace('V', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <div style={{flex: 0.4}}></div>
                    </div>
                    }
                    
                    {/* Ligne Fiches projets synthese globale */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Synthèse globale des projets</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.fp_synthese_globale && props.user.droits.fp_synthese_globale.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.fp_synthese_globale = 'V' + (props.user.droits.fp_synthese_globale ? props.user.droits.fp_synthese_globale:'');
                                }
                                // Enlever un V
                                else {
                                    props.user.droits.fp_synthese_globale = props.user.droits.fp_synthese_globale ? props.user.droits.fp_synthese_globale.replace('V', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <div style={{flex: 0.4}}></div>
                    </div>
                    }
                </div>



                {/************************** PARTIE PROSPECTIVE **************************/}

                <div className='shadow-md rounded-md' style={{margin: 30, marginTop: 50, padding: 10, backgroundColor: 'white'}}>

                    <p style={{fontWeight: 'bold'}}>Prospective</p>

                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', fontSize: 10}}>
                        <div style={{flex: 2}}></div>
                        <button
                            style={{flex: 0.4}}
                            onClick={() => {
                                // Enlever les droits visu et modif sur toutes les lignes
                                if (visuProspective === true) {
                                    props.user.droits.prosp_saisie = props.user.droits.prosp_saisie ? props.user.droits.prosp_saisie.replace('V', '').replace('M', ''):'';
                                    props.user.droits.prosp_saisie_fiscalite = props.user.droits.prosp_saisie_fiscalite ? props.user.droits.prosp_saisie_fiscalite.replace('V', '').replace('M', ''):'';
                                    props.user.droits.prosp_saisie_commentaire = props.user.droits.prosp_saisie_commentaire ? props.user.droits.prosp_saisie_commentaire.replace('V', '').replace('M', ''):'';
                                    props.user.droits.prosp_restitution = props.user.droits.prosp_restitution ? props.user.droits.prosp_restitution.replace('V', ''):'';
                                    props.user.droits.prosp_saisie_emprunt_manuel = props.user.droits.prosp_saisie_emprunt_manuel ? props.user.droits.prosp_saisie_emprunt_manuel.replace('V', '').replace('M', ''):'';
                                    props.user.droits.prosp_saisie_emprunt_auto = props.user.droits.prosp_saisie_emprunt_auto ? props.user.droits.prosp_saisie_emprunt_auto.replace('M', ''):'';
                                    setVisuProspective(false);
                                    setModifProspective(false);
                                }
                                else {
                                    // Enlever les V et M sur toutes les lignes pour ensuite ajouter un V
                                    props.user.droits.prosp_saisie = props.user.droits.prosp_saisie ? props.user.droits.prosp_saisie.replace('V', ''):'';
                                    props.user.droits.prosp_saisie_fiscalite = props.user.droits.prosp_saisie_fiscalite ? props.user.droits.prosp_saisie_fiscalite.replace('V', ''):'';
                                    props.user.droits.prosp_saisie_commentaire = props.user.droits.prosp_saisie_commentaire ? props.user.droits.prosp_saisie_commentaire.replace('V', ''):'';
                                    props.user.droits.prosp_restitution = props.user.droits.prosp_restitution ? props.user.droits.prosp_restitution.replace('V', ''):'';
                                    props.user.droits.prosp_saisie_emprunt_manuel = props.user.droits.prosp_saisie_emprunt_manuel ? props.user.droits.prosp_saisie_emprunt_manuel.replace('V', ''):'';

                                    props.user.droits.prosp_saisie = 'V' + (props.user.droits.prosp_saisie ? props.user.droits.prosp_saisie:'');
                                    props.user.droits.prosp_saisie_fiscalite = 'V' + (props.user.droits.prosp_saisie_fiscalite ? props.user.droits.prosp_saisie_fiscalite:'');
                                    props.user.droits.prosp_saisie_commentaire = 'V' + (props.user.droits.prosp_saisie_commentaire ? props.user.droits.prosp_saisie_commentaire:'');
                                    props.user.droits.prosp_restitution = 'V' + (props.user.droits.prosp_restitution ? props.user.droits.prosp_restitution:'');
                                    props.user.droits.prosp_saisie_emprunt_manuel = 'V' + (props.user.droits.prosp_saisie_emprunt_manuel ? props.user.droits.prosp_saisie_emprunt_manuel:'');
                                    setVisuProspective(true);
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then(() => {
                                    setAff(!aff);
                                })
                            }}>
                            <p>Visualisation</p>
                            <p style={{fontSize: 7}}>(tout cocher))</p>
                        </button>
                        <div style={{width: 15}}></div>
                        <button
                            style={{flex: 0.4}}
                            onClick={() => {
                                if (modifProspective === true) {
                                    // Enlever les droits modif M sur toutes les lignes
                                    props.user.droits.prosp_saisie = props.user.droits.prosp_saisie ? props.user.droits.prosp_saisie.replace('M', ''):'';
                                    props.user.droits.prosp_saisie_fiscalite = props.user.droits.prosp_saisie_fiscalite ? props.user.droits.prosp_saisie_fiscalite.replace('M', ''):'';
                                    props.user.droits.prosp_saisie_commentaire = props.user.droits.prosp_saisie_commentaire ? props.user.droits.prosp_saisie_commentaire.replace('M', ''):'';
                                    props.user.droits.prosp_saisie_emprunt_manuel = props.user.droits.prosp_saisie_emprunt_manuel ? props.user.droits.prosp_saisie_emprunt_manuel.replace('M', ''):'';
                                    props.user.droits.prosp_saisie_emprunt_auto = props.user.droits.prosp_saisie_emprunt_auto ? props.user.droits.prosp_saisie_emprunt_auto.replace('M', ''):'';
                                    setModifProspective(false);
                                }
                                else {
                                    // Ajoute un V et un M
                                    props.user.droits.prosp_saisie = 'VM';
                                    props.user.droits.prosp_saisie_fiscalite = 'VM';
                                    props.user.droits.prosp_saisie_commentaire = 'VM';
                                    props.user.droits.prosp_restitution = 'V';
                                    props.user.droits.prosp_saisie_emprunt_manuel = 'VM';
                                    props.user.droits.prosp_saisie_emprunt_auto = 'VM';
                                    setModifProspective(true);
                                    setVisuProspective(true);
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then(() => {
                                    setAff(!aff);
                                })
                            }}>
                            <p>Modification</p>
                            <p style={{fontSize: 7}}>(tout cocher))</p>
                        </button>
                    </div>
                    
                    {/* Ligne saisies prospective */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Saisie prospective</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.prosp_saisie && props.user.droits.prosp_saisie.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.prosp_saisie = 'V' + (props.user.droits.prosp_saisie ? props.user.droits.prosp_saisie:'');
                                }
                                // Enlever un V et un M
                                else {
                                    props.user.droits.prosp_saisie = props.user.droits.prosp_saisie ? props.user.droits.prosp_saisie.replace('V', '').replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.prosp_saisie && props.user.droits.prosp_saisie.includes('M')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V et un M
                                if (e.target.checked === true) {
                                    props.user.droits.prosp_saisie = 'VM';
                                }
                                // Enlever un M
                                else {
                                    props.user.droits.prosp_saisie = props.user.droits.prosp_saisie ? props.user.droits.prosp_saisie.replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                    </div>
                    }
                    
                    {/* Ligne saisie fiscalite prospective */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Saisie fiscalité prospective</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.prosp_saisie_fiscalite && props.user.droits.prosp_saisie_fiscalite.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.prosp_saisie_fiscalite = 'V' + (props.user.droits.prosp_saisie_fiscalite ? props.user.droits.prosp_saisie_fiscalite:'');
                                }
                                // Enlever un V et un M
                                else {
                                    props.user.droits.prosp_saisie_fiscalite = props.user.droits.prosp_saisie_fiscalite ? props.user.droits.prosp_saisie_fiscalite.replace('V', '').replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.prosp_saisie_fiscalite && props.user.droits.prosp_saisie_fiscalite.includes('M')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V et un M
                                if (e.target.checked === true) {
                                    props.user.droits.prosp_saisie_fiscalite = 'VM';
                                }
                                // Enlever un M
                                else {
                                    props.user.droits.prosp_saisie_fiscalite = props.user.droits.prosp_saisie_fiscalite ? props.user.droits.prosp_saisie_fiscalite.replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                    </div>
                    }
                    
                    {/* Ligne saisie commentaire */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Saisie des commentaires</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.prosp_saisie_commentaire && props.user.droits.prosp_saisie_commentaire.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.prosp_saisie_commentaire = 'V' + (props.user.droits.prosp_saisie_commentaire ? props.user.droits.prosp_saisie_commentaire:'');
                                }
                                // Enlever un V et un M
                                else {
                                    props.user.droits.prosp_saisie_commentaire = props.user.droits.prosp_saisie_commentaire ? props.user.droits.prosp_saisie_commentaire.replace('V', '').replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.prosp_saisie_commentaire && props.user.droits.prosp_saisie_commentaire.includes('M')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V et un M
                                if (e.target.checked === true) {
                                    props.user.droits.prosp_saisie_commentaire = 'VM';
                                }
                                // Enlever un M
                                else {
                                    props.user.droits.prosp_saisie_commentaire = props.user.droits.prosp_saisie_commentaire ? props.user.droits.prosp_saisie_commentaire.replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                    </div>
                    }
                    
                    {/* Ligne restitution prospective */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Restitution de la prospective</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.prosp_restitution && props.user.droits.prosp_restitution.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.prosp_restitution = 'V' + (props.user.droits.prosp_restitution ? props.user.droits.prosp_restitution:'');
                                }
                                // Enlever un V
                                else {
                                    props.user.droits.prosp_restitution = props.user.droits.prosp_restitution ? props.user.droits.prosp_restitution.replace('V', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <div style={{flex: 0.4}}></div>
                    </div>
                    }
                    
                    {/* Ligne emprunts manuels */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Saisie des emprunts futurs</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.prosp_saisie_emprunt_manuel && props.user.droits.prosp_saisie_emprunt_manuel.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.prosp_saisie_emprunt_manuel = 'V' + (props.user.droits.prosp_saisie_emprunt_manuel ? props.user.droits.prosp_saisie_emprunt_manuel:'');
                                }
                                // Enlever un V et un M
                                else {
                                    props.user.droits.prosp_saisie_emprunt_manuel = props.user.droits.prosp_saisie_emprunt_manuel ? props.user.droits.prosp_saisie_emprunt_manuel.replace('V', '').replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.prosp_saisie_emprunt_manuel && props.user.droits.prosp_saisie_emprunt_manuel.includes('M')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V et un M
                                if (e.target.checked === true) {
                                    props.user.droits.prosp_saisie_emprunt_manuel = 'VM';
                                }
                                // Enlever un M
                                else {
                                    props.user.droits.prosp_saisie_emprunt_manuel = props.user.droits.prosp_saisie_emprunt_manuel ? props.user.droits.prosp_saisie_emprunt_manuel.replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                    </div>
                    }
                    
                    {/* Ligne emprunts auto */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Calcul automatique des emprunts d'équilibre</p>
                        <div style={{flex: 0.4}}></div>
                        <div style={{width: 15}}></div>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.prosp_saisie_emprunt_auto && props.user.droits.prosp_saisie_emprunt_auto.includes('M')? true : false}
                            onChange={async(e) => {
                                // Ajouter un M
                                if (e.target.checked === true) {
                                    props.user.droits.prosp_saisie_emprunt_auto = props.user.droits.prosp_saisie_emprunt_auto ? props.user.droits.prosp_saisie_emprunt_auto:'' + 'M';
                                }
                                // Enlever un M
                                else {
                                    props.user.droits.prosp_saisie_emprunt_auto = props.user.droits.prosp_saisie_emprunt_auto ? props.user.droits.prosp_saisie_emprunt_auto.replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                    </div>
                    }
                </div>



                {/************************** PARTIE TABLEAU DE BORD **************************/}

                <div className='shadow-md rounded-md' style={{margin: 30, marginTop: 50, padding: 10, backgroundColor: 'white'}}>

                    <p style={{fontWeight: 'bold'}}>Tableau de bord</p>

                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', fontSize: 10}}>
                        <div style={{flex: 2}}></div>
                        <button
                            style={{flex: 0.4}}
                            onClick={() => {
                                // Enlever les droits visu V et modif M sur toutes les lignes
                                if (visuTableaudeBord === true) {
                                    props.user.droits.tdb_saisie = props.user.droits.tdb_saisie ? props.user.droits.tdb_saisie.replace('V', '').replace('M', ''):'';
                                    props.user.droits.tdb_rapport = props.user.droits.tdb_rapport ? props.user.droits.tdb_rapport.replace('V', ''):'';
                                    setVisuTableaudeBord(false);
                                    setModifTableaudeBord(false);
                                }
                                else {
                                    // Enlever les V sur toutes les lignes pour ensuite ajouter un V
                                    props.user.droits.tdb_saisie = props.user.droits.tdb_saisie ? props.user.droits.tdb_saisie.replace('V', ''):'';
                                    props.user.droits.tdb_rapport = props.user.droits.tdb_rapport ? props.user.droits.tdb_rapport.replace('V', ''):'';
                                    
                                    props.user.droits.tdb_saisie = 'V' + (props.user.droits.tdb_saisie ? props.user.droits.tdb_saisie:'');
                                    props.user.droits.tdb_rapport = 'V' + (props.user.droits.tdb_rapport ? props.user.droits.tdb_rapport:'');
                                    setVisuTableaudeBord(true);
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then(() => {
                                    setAff(!aff);
                                })
                            }}>
                            <p>Visualisation</p>
                            <p style={{fontSize: 7}}>(tout cocher))</p>
                        </button>
                        <div style={{width: 15}}></div>
                        <button
                            style={{flex: 0.4}}
                            onClick={() => {
                                if (modifTableaudeBord === true) {
                                    props.user.droits.tdb_saisie = props.user.droits.tdb_saisie ? props.user.droits.tdb_saisie.replace('M', ''):'';
                                    setModifTableaudeBord(false);
                                }
                                else {
                                    props.user.droits.tdb_saisie = 'VM';
                                    props.user.droits.tdb_rapport = 'V';
                                    setModifTableaudeBord(true);
                                    setVisuTableaudeBord(true);
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then(() => {
                                    setAff(!aff);
                                })
                            }}>
                            <p>Modification</p>
                            <p style={{fontSize: 7}}>(tout cocher))</p>
                        </button>
                    </div>
                    
                    {/* Ligne Tableau de bord saisie */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Saisie du tableau de bord mensuel</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.tdb_saisie && props.user.droits.tdb_saisie.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.tdb_saisie = 'V' + (props.user.droits.tdb_saisie ? props.user.droits.tdb_saisie:'');
                                }
                                // Enlever un V et un M
                                else {
                                    props.user.droits.tdb_saisie = props.user.droits.tdb_saisie ? props.user.droits.tdb_saisie.replace('V', '').replace('M', ''):'';
                                    setModifTableaudeBord(false);
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.tdb_saisie && props.user.droits.tdb_saisie.includes('M')? true : false}
                            onChange={async(e) => {
                                // Ajouter un M et un V
                                if (e.target.checked === true) {
                                    props.user.droits.tdb_saisie = 'VM';
                                }
                                // Enlever un M
                                else {
                                    props.user.droits.tdb_saisie = props.user.droits.tdb_saisie ? props.user.droits.tdb_saisie.replace('M', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                    </div>
                    }
                    
                    {/* Ligne Tableau de bord rapport */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Rapport du tableau de bord mensuel</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.tdb_rapport && props.user.droits.tdb_rapport.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.tdb_rapport = 'V' + (props.user.droits.tdb_rapport ? props.user.droits.tdb_rapport:'');
                                }
                                // Enlever un V
                                else {
                                    props.user.droits.tdb_rapport = props.user.droits.tdb_rapport ? props.user.droits.tdb_rapport.replace('V', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <p style={{flex: 0.4}}></p>
                    </div>
                    }
                </div>



                {/************************** PARTIE GRAPHIQUES **************************/}

                <div className='shadow-md rounded-md' style={{margin: 30, marginTop: 50, padding: 10, backgroundColor: 'white'}}>

                    <p style={{fontWeight: 'bold'}}>Graphiques</p>

                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', fontSize: 10}}>
                        <div style={{flex: 2}}></div>
                        <button
                            style={{flex: 0.4}}
                            onClick={() => {
                                if (visuGraphiques === true) {
                                    props.user.droits.graphiques = props.user.droits.graphiques ? props.user.droits.graphiques.replace('V', ''):'';
                                    setVisuGraphiques(false);
                                }
                                else {
                                    // Enlever les V sur toutes les lignes pour ensuite ajouter un V
                                    props.user.droits.graphiques = props.user.droits.graphiques ? props.user.droits.graphiques.replace('V', ''):'';
                                    
                                    props.user.droits.graphiques = 'V' + (props.user.droits.graphiques ? props.user.droits.graphiques:'');
                                    setVisuGraphiques(true);
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then(() => {
                                    setAff(!aff);
                                })
                            }}>
                            <p>Visualisation</p>
                            <p style={{fontSize: 7}}>(tout cocher))</p>
                        </button>
                        <div style={{width: 15}}></div>
                        <p style={{flex: 0.4}}></p>
                    </div>
                    
                    {/* Ligne Graphiques */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Graphiques</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.graphiques && props.user.droits.graphiques.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.graphiques = 'V' + (props.user.droits.graphiques?props.user.droits.graphiques:'');
                                }
                                // Enlever un V
                                else {
                                    props.user.droits.graphiques = props.user.droits.graphiques ? props.user.droits.graphiques.replace('V', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <div style={{flex: 0.4}}></div>
                    </div>
                    }
                </div>



                {/************************** PARTIE RAPPORT FINANCIER **************************/}

                <div className='shadow-md rounded-md' style={{margin: 30, marginTop: 50, padding: 10, backgroundColor: 'white'}}>

                    <p style={{fontWeight: 'bold'}}>Rapport financier</p>

                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', fontSize: 10}}>
                        <div style={{flex: 2}}></div>
                        
                        <button
                            style={{flex: 0.4}}
                            onClick={() => {
                                if (visuRapportFinancier === true) {
                                    props.user.droits.rapport_financier = props.user.droits.rapport_financier ? props.user.droits.rapport_financier.replace('V', ''):'';
                                    setVisuRapportFinancier(false);
                                }
                                else {
                                    // Enlever les V sur toutes les lignes pour ensuite ajouter un V
                                    props.user.droits.rapport_financier = props.user.droits.rapport_financier ? props.user.droits.rapport_financier.replace('V', ''):'';
                                    
                                    props.user.droits.rapport_financier = 'V' + (props.user.droits.rapport_financier ? props.user.droits.rapport_financier:'');
                                    setVisuRapportFinancier(true);
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then(() => {
                                    setAff(!aff);
                                })
                            }}>
                            <p>Visualisation</p>
                            <p style={{fontSize: 7}}>(tout cocher))</p>
                        </button>
                        <div style={{width: 15}}></div>
                        <p style={{flex: 0.4}}></p>
                    </div>
                    
                    {/* Ligne Graphiques */}
                    {props.user.droits && 
                    <div style={{display: 'flex', marginTop: 10, alignItems: 'center', justifyContent: 'center', textAlign: 'left', fontSize: 14}}>
                        <p style={{flex: 2}}>Édition du rapport financier</p>
                        <input
                            style={{flex: 0.4}}
                            type="checkbox"
                            checked={props.user.droits.rapport_financier && props.user.droits.rapport_financier.includes('V')? true : false}
                            onChange={async(e) => {
                                // Ajouter un V
                                if (e.target.checked === true) {
                                    props.user.droits.rapport_financier = 'V' + (props.user.droits.rapport_financier ? props.user.droits.rapport_financier:'');
                                }
                                // Enlever un V
                                else {
                                    props.user.droits.rapport_financier = props.user.droits.rapport_financier ? props.user.droits.rapport_financier.replace('V', ''):'';
                                }
                                var params = {
                                    'updateDroits': true,
                                    'id': props.user.id,
                                    'droits': props.user.droits
                                };
                                axios.post("https://app-slfinance.fr/api/droits.php", qs.stringify(params))
                                .then((e) => {
                                    setAff(!aff);
                                })
                            }}
                        />
                        <div style={{width: 15}}></div>
                        <div style={{flex: 0.4}}></div>
                    </div>
                    }
                </div>

            </div>
        </Modal>
    );
};

export default ModalUpdateUser;